/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deviceIntegrationsListFleetDevices } from "../funcs/deviceIntegrationsListFleetDevices.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  CoverageBucket,
  ListFleetDevicesRequest,
  ListFleetDevicesResponse,
  ListFleetDevicesSecurity,
  PolicyState,
} from "../models/operations/listfleetdevices.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type FleetDevicesQueryData = ListFleetDevicesResponse;

export type FleetDevicesInfiniteQueryData = PageIterator<
  ListFleetDevicesResponse,
  { cursor: string }
>;

export type FleetDevicesPageParams = PageIterator<
  ListFleetDevicesResponse,
  { cursor: string }
>["~next"];

export function prefetchFleetDevices(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListFleetDevicesRequest | undefined,
  security?: ListFleetDevicesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildFleetDevicesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchFleetDevicesInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListFleetDevicesRequest | undefined,
  security?: ListFleetDevicesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildFleetDevicesInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as FleetDevicesPageParams,
    getNextPageParam: (previousPage: FleetDevicesInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildFleetDevicesQuery(
  client$: GramCore,
  request?: ListFleetDevicesRequest | undefined,
  security?: ListFleetDevicesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<FleetDevicesQueryData>;
} {
  return {
    queryKey: queryKeyFleetDevices({
      provider: request?.provider,
      inInventory: request?.inInventory,
      coverageBucket: request?.coverageBucket,
      policyState: request?.policyState,
      userIds: request?.userIds,
      userEmails: request?.userEmails,
      cursor: request?.cursor,
      limit: request?.limit,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function fleetDevicesQueryFn(
      ctx,
    ): Promise<FleetDevicesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(deviceIntegrationsListFleetDevices(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildFleetDevicesInfiniteQuery(
  client$: GramCore,
  request?: ListFleetDevicesRequest | undefined,
  security?: ListFleetDevicesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, FleetDevicesPageParams>,
  ) => Promise<FleetDevicesInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyFleetDevicesInfinite({
      provider: request?.provider,
      inInventory: request?.inInventory,
      coverageBucket: request?.coverageBucket,
      policyState: request?.policyState,
      userIds: request?.userIds,
      userEmails: request?.userEmails,
      cursor: request?.cursor,
      limit: request?.limit,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function fleetDevicesQuery(
      ctx,
    ): Promise<FleetDevicesInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(
          deviceIntegrationsListFleetDevices(
            client$,
            request,
            security,
            mergedOptions,
          ),
        );
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(
        deviceIntegrationsListFleetDevices(
          client$,
          {
            ...request!,
            cursor: ctx.pageParam.cursor,
          },
          security,
          mergedOptions,
        ),
      );
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyFleetDevices(
  parameters: {
    provider?: string | undefined;
    inInventory?: boolean | undefined;
    coverageBucket?: CoverageBucket | undefined;
    policyState?: PolicyState | undefined;
    userIds?: Array<string> | undefined;
    userEmails?: Array<string> | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "deviceIntegrations", "listFleetDevices", parameters];
}

export function queryKeyFleetDevicesInfinite(
  parameters: {
    provider?: string | undefined;
    inInventory?: boolean | undefined;
    coverageBucket?: CoverageBucket | undefined;
    policyState?: PolicyState | undefined;
    userIds?: Array<string> | undefined;
    userEmails?: Array<string> | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "deviceIntegrations",
    "listFleetDevices",
    "infinite",
    parameters,
  ];
}
